var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#21A6E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.3799C9 10.8279 9.186 10.3779 9.558 10.0299C9.93 9.68194 10.428 9.50794 11.052 9.50794C11.676 9.50794 12.174 9.68494 12.546 10.0389C12.918 10.3929 13.104 10.8579 13.104 11.4339C13.104 11.9499 12.912 12.3849 12.528 12.7389C12.144 13.0929 11.646 13.2699 11.034 13.2699H11.016C10.404 13.2699 9.915 13.0899 9.549 12.7299C9.183 12.3699 9 11.9199 9 11.3799ZM9.216 25.6899V14.7639H12.852V25.6899H9.216ZM14.868 25.6899H18.522V19.5879C18.522 19.2039 18.564 18.9099 18.648 18.7059C18.792 18.3339 19.026 18.0189 19.35 17.7609C19.674 17.5029 20.064 17.3739 20.52 17.3739C21.744 17.3739 22.356 18.2019 22.356 19.8579V25.6899H25.992V19.4259C25.992 17.7939 25.611 16.5669 24.849 15.7449C24.087 14.9229 23.076 14.5119 21.816 14.5119C20.388 14.5119 19.29 15.1119 18.522 16.3119V16.3479H18.504L18.522 16.3119V14.7639H14.868C14.892 15.2199 14.904 16.3059 14.904 18.0219C14.904 18.9459 14.898 20.7639 14.886 23.4759L14.868 25.6899Z",
    fill: "#F8FAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.9d670296786acb2e587ad1e3d1585bad.svg";
export { ForwardRef as ReactComponent };